import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'tm-indeterminate-progress-bar',
  templateUrl: './indeterminate-progress-bar.component.html',
  styleUrls: ['./indeterminate-progress-bar.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class IndeterminateProgressBarComponent implements OnInit {
  isShow = false;

  constructor() { }

  ngOnInit() {
  }

  show(): void {
    this.isShow = true;
  }

  hide(): void {
    this.isShow = false;
  }
}
